if (!customElements.get('product-form')) {

  certifiedCustomersModal();

  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      
      this.form = this.querySelector('form');
      const idField = this.form.querySelector('[name=id]');
      if (idField) { idField.disabled = false; };
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.b2bSubmit = this.querySelector('[type="button"][name="add"]');
      this.cartNotification = document.getElementById('cart-notification');
      this.cartNotificationItem = document.getElementById('cart-notification-item');
      this.multi_item_request = false;

      if (this.b2bSubmit) {
        this.b2bSubmit.addEventListener('click', this.onB2BSubmitHandler.bind(this));
      } 
    }

  
    async onB2BSubmitHandler(evt) {
          console.log("B2B Submit clicked");
          if (window.customerCompanyOnHold === true) {
          showOnHoldModal();
          return;
        }


      const form = document.getElementById('ProductVariantTarget');
      
      // Validate: Check if at least one variant has quantity > 0
      const allQuantityInputs = form.querySelectorAll('.variant-row .quantity__input');
      const hasSelection = Array.from(allQuantityInputs).some(input => parseInt(input.value) > 0);
      
      if (!hasSelection) {
        Woolman.ModalsAndDrawers.showModalOrDrawer('modal-variant-validation');
        return;
      }
      
      this.b2bSubmit.setAttribute('aria-disabled', true);
      this.b2bSubmit.classList.add('loading');
      this.querySelector('.loading-overlay').classList.remove('hidden');

      // Loop through all .variant-row and add the data-variant-id to cart with quantity
      // (Find quantity named input.) Do not add if value is not greater than 0

      const variantRows = form.querySelectorAll('.variant-row');
      const items = []; 

      variantRows?.forEach(row => {
        const variantId = row.getAttribute('data-variant-id');
        const quantity = parseInt(row.querySelector('.quantity__input')?.value);

        /*if (quantity > 0) {
          items.push({ id: variantId, quantity: quantity,
                  properties: { _uuid: Date.now() + '_' + Math.random().toString(36).slice(2, 8) }

           });
           console.log("Adding to cart", items);
        }*/
       if (quantity > 0) {
        for (let i = 0; i < quantity; i++) {
          items.push({
            id: variantId,
            quantity: 1,
            properties: { 
              _uuid: Date.now() + '_' + Math.random().toString(36).slice(2, 10),
              _first_name: row.querySelector('.first-name') ? row.querySelector('.first-name').value : '',
              _last_name: row.querySelector('.last-name') ? row.querySelector('.last-name').value : '',
              _email: row.querySelector('.email') ? row.querySelector('.email').value : '',
              _phone: row.querySelector('.phone') ? row.querySelector('.phone').value : '',
              _gender: row.querySelector('.gender') ? row.querySelector('.gender').value : '',
              _dob: row.querySelector('.dob') ? row.querySelector('.dob').value : '',
              _job_title: row.querySelector('.job-title') ? row.querySelector('.job-title').value : '',
              _dietary_requirements: row.querySelector('.dietary-requirements') ? row.querySelector('.dietary-requirements').value : '',
              _additional_comments: row.querySelector('.additional-comments') ? row.querySelector('.additional-comments').value : '',
              _delegate_index: row.querySelector('.delegate-index') ? row.querySelector('.delegate-index').value : '',
            }
          });
        }
        console.log("Adding to cart", items);
        window.lastAddedVariants = items.map(item => item.id);
      }
      });

      // Upsell items handled only in JS
      const upsell_ids_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-id`);
      const upsell_quantities_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`);
      const upsellQuantityInput = document.querySelector('.upsell-bundle');
      let upsell_items = [];

      if (upsell_ids_nodes.length !== 0 && !upsellQuantityInput) {
        const upsell_ids = Array.from(upsell_ids_nodes).map(input => parseInt(input.value));
        const upsell_quantities = Array.from(upsell_quantities_nodes).map(input => parseInt(input.value));
        upsell_items = upsell_ids.map((id, index) => ({'id': id,'quantity': upsell_quantities[index]})).filter(item => item.quantity !== 0);
      }
 
      // If upsell items added refactor FormData
      if (upsell_items.length > 0) {
        items.push(...upsell_items);
      }

      if (items.length === 0) {

        this.handleErrorMessage(window.variantStrings.noItemsSelected);
        this.b2bSubmit.classList.remove('loading');
        this.b2bSubmit.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay').classList.add('hidden');
        return;

      };

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body: JSON.stringify({ items: items })
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config);
        const json = await res.json();

       // remove error message if one is visible
       /* const errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
        if (errorMessageWrapper) {
          errorMessageWrapper.setAttribute('hidden', '');
        }*/

        if (res.status !== 200) throw new Error(json.description);

        if (this.cartNotification) {
          const notificationTemplate = document.importNode(this.cartNotification.content, true);

          notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemsAdded;
          json.items.forEach(item => {
            const singleItem = this.createNotificationItem(item);
            notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
          });

          if (document.querySelector('.cart-notification')) {
            document.querySelector('.cart-notification').remove();
          }

          document.querySelector('.site-header').appendChild(notificationTemplate);
          const the_notification = document.querySelector('.cart-notification');
          the_notification.querySelector('.notification-close').addEventListener('click', () => {
            the_notification.classList.remove('anim-in');
          });
          setTimeout(() => {
            the_notification.classList.add('anim-in');
          }, 50);
        }

        const event = new CustomEvent('ajaxProduct:added')

        document.dispatchEvent(event)
      } catch(error) {
        this.handleErrorMessage(error);
        console.error(error);
      } finally {
        this.b2bSubmit.classList.remove('loading');
        this.b2bSubmit.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay').classList.add('hidden');

        // Reset quantity inputs for visible variant rows
        variantRows?.forEach(row => {
          if (!row.classList.contains('hide')) {
            const quantityInput = row.querySelector('.quantity__input');
            if (quantityInput) {
              quantityInput.value = 0; 
            }
          }
        });

        const addToCartPopup = document.querySelector('.add_to_cart_popup');
        if (addToCartPopup && addToCartPopup.hasAttribute('hidden')) {
          addToCartPopup.removeAttribute('hidden');
        }

        if (upsellQuantityInput) {
          const productFormSubmit = upsellQuantityInput.closest('form').querySelector('.product-form__submit');
          if (productFormSubmit) {
            productFormSubmit.removeAttribute('disabled');
          }
        }


      }


    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay').classList.remove('hidden');

      // Upsell items handled only in JS
      const upsell_ids_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-id`);
      const upsell_quantities_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`);
      let upsell_items = [];

      if (upsell_ids_nodes.length !== 0) {
        const upsell_ids = Array.from(upsell_ids_nodes).map(input => parseInt(input.value));
        const upsell_quantities = Array.from(upsell_quantities_nodes).map(input => parseInt(input.value));
        upsell_items = upsell_ids.map((id, index) => ({'id': id,'quantity': upsell_quantities[index]})).filter(item => item.quantity !== 0);
      }

      const config = { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        }
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      // If upsell items added refactor FormData
      if (upsell_items.length > 0) {
        this.multi_item_request = true;
        const items = upsell_items;
        const id = parseInt(formData.get('id'));
        const upsellQuantityInput = document.querySelector('.upsell-bundle');
        let quantity = parseInt(formData.get('quantity')) || 1;
        if (upsellQuantityInput != null) { 
          quantity = upsellQuantityInput.value - 1;
        } 
        console.log("this is pod racing", quantity)

        const the_product_item = { 'id': id, 'quantity': quantity }

        items.push(the_product_item);
        const itemsData = { 'items': items };

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(itemsData);

        if (upsellQuantityInput) {
          const productFormSubmit = upsellQuantityInput.closest('form').querySelector('.product-form__submit');
          if (productFormSubmit) {
            productFormSubmit.setAttribute('disabled', true);
            upsellQuantityInput.value = 0
          }
          const addToCartPopup = document.querySelector('.add_to_cart_text');
          if (addToCartPopup) {
            addToCartPopup.innerHTML = quantity+1 + " bundle items added to cart";
            console.log("added to cart", addToCartPopup.innerHTML);
          }
        }
      } else {
        if (window.customerCompanyOnHold === true) {
          showOnHoldModal();
          return;
        }
        // Custom logic for single-variant online courses
        const id = parseInt(formData.get('id'));
        let quantity = parseInt(formData.get('quantity')) || 1;
        let items = [];

        // Detect if this is a single-variant product with Format: Online in description
        let isSingleVariant = false;
        let isOnlineCourse = false;
        // Check for single variant (no variant selector)
        if (!document.querySelector('.product-form__input--dropdown, .product-form__input--radio')) {
          isSingleVariant = true;
        }
        // Check for Format: Online in description
        const descElem = document.querySelector('.product-block__text .rte');
        if (descElem && descElem.textContent && descElem.textContent.includes('Format: Online')) {
          console.log("Online course detected");
          isOnlineCourse = true;
        }

        if (isSingleVariant && isOnlineCourse && quantity > 1) {
          // Split into unique cart lines
          for (let i = 0; i < quantity; i++) {
            items.push({
              id: id,
              quantity: 1,
              properties: { _uuid: Date.now() + '_' + Math.random().toString(36).slice(2, 10) }
            });
          }
          this.multi_item_request = true;
        } else {
          // Default behavior
          items.push({ id: id, quantity: quantity });
        }
        const itemsData = { 'items': items };

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(itemsData);
        console.log("formdata " + formData.get('quantity'));
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config)
        const json = await res.json();

        if (res.status !== 200) throw new Error(json.description);

        if (this.cartNotification) {
          const notificationTemplate = document.importNode(this.cartNotification.content, true);

          if (this.multi_item_request) {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemsAdded;
            let lastElement = json.items.pop();
            json.items.unshift(lastElement);

            json.items.forEach(item => {
              const singleItem = this.createNotificationItem(item);
              notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
            });
          } else {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemAdded;
            const singleItem = this.createNotificationItem(json);
            notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
          }

          if (document.querySelector('.cart-notification')) {
            document.querySelector('.cart-notification').remove();
          }

          document.querySelector('.site-header').appendChild(notificationTemplate);
          const the_notification = document.querySelector('.cart-notification');
          the_notification.querySelector('.notification-close').addEventListener('click', () => {
            the_notification.classList.remove('anim-in');
          });
          setTimeout(() => {
            the_notification.classList.add('anim-in');
          }, 50);
        }

        const event = new CustomEvent('ajaxProduct:added')
        document.dispatchEvent(event)
      } catch(error) {
        this.handleErrorMessage(error);
        console.error(error);
      }finally {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay').classList.add('hidden');
        this.resetQuantityInput();

        const addToCartPopup = document.querySelector('.add_to_cart_popup');
        if (addToCartPopup && addToCartPopup.hasAttribute('hidden')) {
          addToCartPopup.removeAttribute('hidden');
        }
      }


    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector(`.product-form__error-message-wrapper[form="${this.form.getAttribute('id')}"]`)
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }

      // Scroll to error container
      this.errorMessageWrapper.scrollIntoView({ behavior: 'smooth' });

    }

    resetQuantityInput() {
      const hidden_quantity_input = document.querySelector('[type=hidden][name=quantity]');
      if (hidden_quantity_input) {
        hidden_quantity_input.value = 1;
      }
    }

    createNotificationItem(product) {
      const notificationItemTemplate = document.importNode(this.cartNotificationItem.content, true);

      const filename = product.image.split('/').pop();
      const lastDotIndex = filename.lastIndexOf('.');
      const newFilename = `${filename.substring(0, lastDotIndex)}_120x${filename.substring(lastDotIndex)}`;
      const url = product.image.replace(filename, newFilename);

      notificationItemTemplate.querySelector('.notification-item-image').setAttribute('src', url);
      notificationItemTemplate.querySelector('.notification-item-image').classList.remove('hide');
      notificationItemTemplate.querySelector('.notification-item-title').textContent = product.product_title;

      product.options_with_values.forEach(item => {
        const row = document.createElement("dl");
        const nameCell = document.createElement("dt");
        const valueCell = document.createElement("dd");

        nameCell.textContent = item.name + ':';
        valueCell.textContent = item.value;

        row.appendChild(nameCell);
        row.appendChild(valueCell);
        notificationItemTemplate.querySelector('.notification-item-details').appendChild(row);
      })

      return notificationItemTemplate;
    }
  });
}

class AddMultiplier extends HTMLElement {
  constructor() {
    super();

    const multiplyButton = this.querySelector('button');
    this.submitEvent = new SubmitEvent("submit", { submitter: multiplyButton });
    this.multiplyBy = parseInt(this.querySelector('[name=multiplied-quantity]').value);
    this.productForm = this.closest('product-form').querySelector('form');
    const formId = this.productForm.getAttribute('id');
    this.quantity_input = document.querySelector(`[name=quantity][form=${ formId }]`);
    multiplyButton.addEventListener('click', this.submitProductForm.bind(this));
  }

  submitProductForm() {
    this.quantity_input.value = this.multiplyBy;
    this.productForm.dispatchEvent(this.submitEvent);
  }
}
customElements.define("add-multiplier", AddMultiplier);


function showOnHoldModal() {
  const dlg = document.getElementById('modal-errors');
  const body = dlg?.querySelector('.modal-body');
  if (body) {
    body.innerHTML = `Your account is on hold and therefore you are not able to place orders at this time. Please call our team to discuss on 0333 015 6626 or email <a href="mailto:sales.enquiries@niceic.com">sales.enquiries@niceic.com</a>`;
  }
  dlg?.classList.add('is-open');
}

   function certifiedCustomersModal() {
      console.log("certifiedCustomersModal called");
      if (window.certifiedCustomers === true) {
      const dlg = document.getElementById('modal-errors');
      const body = dlg?.querySelector('.modal-body');
      if (body) {
        body.innerHTML = `You must login and be certified under the relevant NICEIC scheme to purchase this product`;
      }
      dlg?.classList.add('is-open');
    }
    }